export enum LETTERS_TYPE {
  one_column = 'one_column'
}
